export const screenName = 'boleta-rapida';
